import Box from "@mui/material/Box";
import React, { useRef, useEffect, useState } from "react";

function TaskFieldMinute(props) {
  const refIframe = useRef(null);
  const [loadingComplete, setLoadingComplete] = useState(false);
  function handleIframeEvent({ data }) {
    if (data.action === "loadingComplete") {
      setLoadingComplete(true);
    }
  }

  useEffect(() => {
    window.addEventListener("message", handleIframeEvent);
    return () => {
      window.removeEventListener("message", handleIframeEvent);
    };
  }, []);

  return (
    <Box
      component="iframe"
      ref={refIframe}
      src={`https://document-editor.smartdocs.com.br/?readOnly=true`}
      sx={{
        height: "150",
        width: "100%",
        border: "none",
      }}
    />
  );
}

export default TaskFieldMinute;
